/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EmailAttachment { 
    /**
     * Ruta relativa a uploads/email-attachments/ (p.ej. 2026-10/archivo.pdf)
     */
    fileId: string;
    /**
     * Nombre con el que lo recibe el destinatario
     */
    name: string;
    size?: number;
    mimeType?: string;
}

